

























import { mapState } from "vuex";
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import RequestPromises from "@/mixins/requestPromises";
// Types
import { ILanguage } from "@/models/constants";
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      languages: (state: IState) => state.constants.languages
    })
  }
})
export default class ProviderCurrenciesList extends mixins(RequestPromises) {
  // getters
  private languages!: ILanguage[];

  @Prop({ required: true })
  private isProcessing!: boolean;

  @Prop({ required: true })
  private form!: any;

  @Prop({ required: true })
  private formClone!: any;

  public async created() {
    await this.$store.dispatch("constants/getLanguages");
  }

  private getLanguageValue(languageId: ILanguage["id"]) {
    return !!this.$_.find(this.form.supported_languages, language => {
      return language === languageId;
    });
  }

  private onChange(languageValue: number, languageId: ILanguage["id"]) {
    if (languageValue) {
      this.form.supported_languages.push(languageId);
    } else {
      this.form.supported_languages = this.$_.filter(
        this.form.supported_languages,
        language => {
          return language !== languageId;
        }
      );
    }
  }

  private get canManageBrand() {
    return this.$userCan(`update_brand`);
  }
}
